import * as api from "../Services/api.js";

export const state = {
  posts: [],
  pageNumber: 0,
  totalPosts: 0,
  orderBySort: null,
};

export const mutations = {
  SET_OREDERBY_SORT(state, orderBy) {
    state.orderBySort = orderBy;
  },
  SET_POST(state, payload) {
    state.posts = payload.post_data;
    state.pageNumber = 1;
    state.totalPosts = payload.post_count;
  },
  SET_LOADED_POST(state, payload) {
    state.posts = state.posts.concat(payload.post_data);
    state.pageNumber += 1;
  },
  CHANGE_PRESSURE(state, payload) {
    const index = state.posts.findIndex(
      ({ post_id }) => post_id === payload.post_id
    );
    state.posts[index].votes += payload.amount;
  },
  CHANGE_ORDER(state) {
    state.posts = state.posts.sort((a, b) => {
      if (a.votes > b.votes) {
        return -1;
      } else {
        return 1;
      }
    });
  },
  EDIT_POST(state, payload) {
    const index = state.posts.findIndex(
      ({ post_id }) => post_id === payload.post_id
    );
    state.posts.splice(index, 1, { ...payload });
  },
  REMOVE_POST(state, payload) {
    const index = state.posts.findIndex(({ uuid }) => uuid === payload);
    state.posts.splice(index, 1);
  },
};

export const getters = {
  getOrderBySort(state) {
    return state.orderBySort;
  },
};

export const actions = {
  async getAllAvailablePosts({ commit }, data) {
    return await api
      .get(
        "/posts/leaderboard/?page_num=" +
          data.pageNumber +
          "&active_tab=" +
          data.activeTab +
          "&category=" +
          data.selectedCategory
      )
      .then((response) => {
        commit("SET_POST", response);
        commit("SET_OREDERBY_SORT", response.order_by);
        return response;
      });
  },
  async loadMorePosts({ commit, dispatch, getters }, data) {
    dispatch("setStatus", true, { root: true });
    const tmp = await api
      .get(
        "/posts/leaderboard/?page_num=" +
          data.pageNumber +
          "&active_tab=" +
          data.activeTab +
          "&order_by=" +
          getters.getOrderBySort +
          "&category=" +
          data.selectedCategory
      )
      .then((response) => {
        dispatch("setStatus", false, { root: true });
        commit("SET_LOADED_POST", response);
        return response;
      });
    return tmp;
  },
  async changePressure({ commit }, data) {
    return await api
      .get(
        "/posts/change-vote/?post_id=" + data.post_id + "&amount=" + data.amount
      )
      .then((response) => {
        commit("CHANGE_PRESSURE", data);
        if (data.activeTab === 0) {
          commit("CHANGE_ORDER");
        }
        return response;
      });
  },
  async editPost({ commit }, data) {
    return await api.post("/posts/update/", data).then((response) => {
      if (response.status === 200) {
        commit("EDIT_POST", data);
      }
    });
  },
  async removePost({ commit }, data) {
    return await api.get("/posts/remove-post?uuid=" + data).then((response) => {
      if (response.status === 200) {
        commit("REMOVE_POST", data);
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
